<div class="dialog-wrapper">
  <header class="help-header">
    <div class="help-badge">Help</div>
    <button mat-dialog-close type="button" class="btn-close" aria-label="Close"></button>
  </header>

  <main class="help-content">
    <section>
      <h2>Login or Register</h2>
      <div class="info-item">
        <p><strong>As a buyer:</strong> Browse and buy fruit consignments from top verified global sellers.</p>
        <p><strong>As a seller:</strong> Sell your fruit consignments to the top verified global buyers.</p>
        <p><strong>As an investor:</strong> Access robust market intelligence and track global trade volumes through our specialized investor dashboards.</p>
      </div>
      <p class="platform-note">
        Post registration, our Platform verifies your business details after which you can login and transact. 
        All transactions are facilitated by the platform with payment assurance and claim resolutions.
      </p>
    </section>

    <div class="divider"></div>

    <section>
      <h2>Trade GPT</h2>
      <p class="platform-note">
        Need quick answers? Type your query into Trade GPT to instantly access all information from Agrify's official trade documentation.
      </p>
    </section>

    <div class="divider"></div>

    <section>
      <h2>Contact us</h2>
      <div class="contact-item">
        <div class="icon-circle email">
          <i class="bi bi-envelope-fill"></i>
        </div>
        <div class="contact-info">
          <label>Email:</label>
          <a href="mailto:hi@agrify.ai">hi@agrify.ai</a>
        </div>
      </div>

      <div class="contact-item">
        <div class="icon-circle phone">
          <i class="bi bi-telephone-fill"></i>
        </div>
        <div class="contact-info">
          <label>Phone:</label>
          <a href="tel:+918591117944">+91 8591117944</a>
        </div>
      </div>
    </section>
  </main>

  <footer class="help-footer">
    <button mat-dialog-close class="btn-got-it">Got it</button>
  </footer>
</div>